<template>
  <div
    :title="name"
    :class="{
      'profile-avatar': squared,
      'mate-profile': !squared,
      rounded: !pic,
    }"
    :style="`height: ${size}px; width: ${size}px`"
  >
    <img v-if="pic" :src="url" :alt="name" :class="squared ? 'avatar-img' : 'mate-img'" />
    <div v-else>
      {{ initials }}
    </div>
  </div>
</template>

<script>
  import avatarInitials from '@/utils/formatting/avatar-initials';
  import absoluteLink from '@/utils/formatting/absolute-link';

  export default {
    name: 'Avatar',
    props: {
      name: [String, Number],
      pic: String,
      email: String,

      improveUrl: {
        type: Boolean,
        default: true,
      },

      squared: {
        type: Boolean,
        default: false,
      },

      size: {
        type: [Number, String],
        default: 32,
      },
    },
    computed: {
      url() {
        return this.improveUrl ? absoluteLink(this.pic, true) : this.pic;
      },
      initials() {
        return avatarInitials({
          size: this.size,
          name: this.name,
          email: this.email,
        });
      },
    },
  };
</script>
